<router-outlet></router-outlet>
<app-session-timeout-dialog></app-session-timeout-dialog>
<app-progress-spinner class="example-margin" *ngIf="progressSpinnerConfig.show"></app-progress-spinner>